function AnnouncementIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.12">
        <path
          d="M24.6667 18.0002C27.2441 18.0002 29.3334 15.9108 29.3334 13.3335C29.3334 10.7562 27.2441 8.66683 24.6667 8.66683V18.0002Z"
          fill="currentColor"
        />
        <path
          d="M13.3334 7.3335H8.66675C5.35304 7.3335 2.66674 10.0198 2.66675 13.3335C2.66675 16.6472 5.35304 19.3335 8.66674 19.3335H13.3334L13.3334 7.3335Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M5.33342 18.6666L7.43294 27.0647C7.49199 27.3008 7.52151 27.4189 7.55644 27.522C7.89764 28.5294 8.80477 29.2376 9.86478 29.3243C9.97329 29.3332 10.095 29.3332 10.3385 29.3332C10.6433 29.3332 10.7958 29.3332 10.9242 29.3208C12.1934 29.1977 13.1979 28.1932 13.321 26.924C13.3334 26.7956 13.3334 26.6431 13.3334 26.3383V7.33322M24.6668 17.9999C27.2441 17.9999 29.3334 15.9105 29.3334 13.3332C29.3334 10.7559 27.2441 8.66655 24.6668 8.66655M13.6667 7.33322H8.66675C5.35304 7.33322 2.66675 10.0195 2.66675 13.3332C2.66675 16.6469 5.35304 19.3332 8.66675 19.3332H13.6668C16.022 19.3332 18.9031 20.5957 21.1258 21.8074C22.4225 22.5143 23.0709 22.8677 23.4955 22.8157C23.8893 22.7675 24.187 22.5907 24.4178 22.268C24.6668 21.9201 24.6668 21.2239 24.6668 19.8315V6.83493C24.6668 5.44254 24.6668 4.74635 24.4178 4.3984C24.187 4.07575 23.8893 3.89895 23.4955 3.85072C23.0709 3.79871 22.4225 4.15215 21.1258 4.85902C18.9031 6.0707 16.022 7.33322 13.6667 7.33322Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AnnouncementIcon;
